export default __webpack_public_path__ + "static/media/arrow-down.dc8b4d44.svg";